import { useQuery, useMutation } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'
import { useEffect } from 'react'
import { useGameContext } from '../../screens/GameContainer/GameContext'
import { useGameState } from '../../screens/GameContainer/useGameState'
// import { isCelebrationMessage } from '@/screens/new-design/hooks/useCelebration'
// import { useCelebrationMessages } from './useCelebrationMessages'

/**
 * Hook to fetch and log chat messages for a game
 * Celebration messages are handled separately and filtered from the returned messages
 */
export function useChatMessages(gameId: Id<'games'> | undefined, limit = 50) {
  const allMessages = useQuery(api.chat.queries.getRecentMessages, gameId ? { gameId, limit } : 'skip')

  const messages = allMessages
  // KEEP CELEBRATIONS FOR NOW and for show in chat
  // Filter out celebration messages from returned messages
  // const messages = useMemo(() => {
  //   if (!allMessages) return allMessages
  //   return allMessages.filter((msg) => {
  //     // Filter out celebration messages
  //     if (msg.chatKind === 'engine' && isCelebrationMessage(msg.message)) {
  //       return false
  //     }
  //     return true
  //   })
  // }, [allMessages])

  // Log messages to console for verification
  const logMessages = false
  useEffect(() => {
    if (logMessages && allMessages && allMessages.length > 0) {
      console.log('[Convex Chat POC] Received', allMessages.length, 'messages (celebrations not filtered):')
      allMessages.forEach((msg, index) => {
        console.log(`[${index + 1}] [${msg.chatKind}] ${msg.userName}: ${msg.message} (${msg._creationTime})`)
      })
    }
  }, [allMessages])

  return {
    messages,
    messageCount: messages?.length ?? 0
  }
}

export function useSendChatMessage() {
  const { gameId, userId } = useGameContext()
  const { myPlayer } = useGameState()
  const sendMessage = useMutation(api.chat.mutations.sendMessage)

  const onSendMessageFull = async (
    gameId: Id<'games'>,
    userId: string,
    userName: string,
    message: string,
    chatKind: Parameters<typeof sendMessage>[0]['chatKind'],
    color: string
  ) => {
    try {
      const result = await sendMessage({
        gameId,
        userId,
        userName,
        message,
        chatKind,
        color
      })
      console.log('Message sent successfully:', result)
    } catch (error) {
      console.error('Error sending message:', error)
    }
  }

  const onSendMessage = async (
    message: string,
    chatKind: Parameters<typeof sendMessage>[0]['chatKind'],
    color: string
  ) => {
    if (!(gameId && userId)) {
      console.warn('Cannot send message: gameId or userId is missing')
      return
    }
    onSendMessageFull(gameId, userId, myPlayer?.name || 'Someone', message, chatKind, color)
  }

  return { onSendMessageFull, onSendMessage }
}
